import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
} : {
  name: "19b1yv2-containerStyles",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;label:containerStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNyb3BwYWJsZUNvbnRlbnRTdHlsZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdJIiwiZmlsZSI6IkNyb3BwYWJsZUNvbnRlbnRTdHlsZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgY29udGFpbmVyU3R5bGVzID0gKCk6IFNlcmlhbGl6ZWRTdHlsZXMgPT5cbiAgICBjc3Moe1xuICAgICAgICB0ZXh0T3ZlcmZsb3c6ICdlbGxpcHNpcycsXG4gICAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgfSk7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const containerStyles = () => _ref;

export { containerStyles };
//# sourceMappingURL=CroppableContentStyles.js.map
